"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _typeof2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("@/components/foot-nav.vue"));
var _noNavFoolist = _interopRequireDefault(require("@/components/news/noNavFoolist.vue"));
var _api = require("../../../api/api");
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'newMsdsList',
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default,
    list: _noNavFoolist.default
  },
  data: function data() {
    return {
      searchIcoSrc: require("../../../assets/static/img/msds/search_logo.png"),
      isNodata: false,
      isNoMoredata: false,
      searchInput: this.$route.query.searchVal,
      isSearch: this.$route.query.isSearch + '',
      //区分搜索
      isDetail: this.$route.query.isDetail + '',
      //区分详情
      hasHeaderShadow: false,
      //header的下滑阴影
      menuActive: this.$route.query.menuActive ? this.$route.query.menuActive : 0,
      listData: {
        content: []
      },
      //列表数据
      advertData: '',
      //广告
      carouselData: '',
      //轮播
      page: {
        pageNo: 1,
        pageSize: 10
      },
      //列表请求参数
      hotspotData: [],
      showAppDialog: false
    };
  },
  created: function created() {
    this.getAdvertData('PC_MSDS_LIST', '');
    this.gethotspotData();
    this.getMsdsList();
  },
  mounted: function mounted() {
    var that = this;
    that.$refs.content.addEventListener('scroll', that.throttle(that.handleScroll));
  },
  methods: {
    // 搜索
    toSearch: function toSearch() {
      var that = this;
      if (that.searchInput) {
        this.page.pageNo = 1;
        this.getMsdsList(true, false);
        this.gethotspotData();
      } else {
        this.$message({
          message: '请输入你想要搜索的内容',
          type: 'warning',
          duration: '1000'
        });
      }
    },
    // 更多列表
    getMoreMsdsList: function getMoreMsdsList() {
      this.page.pageNo++;
      this.getMsdsList(false, true);
    },
    // 请求Msds列表
    getMsdsList: function () {
      var _getMsdsList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var isSearch,
          isMore,
          scrollTop,
          loadInstance,
          that,
          param,
          jsonParam,
          _yield$apiGetMsdsDesc,
          data,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isSearch = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              isMore = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              scrollTop = 0;
              if (isMore) {
                scrollTop = this.$refs.content.scrollTop;
              }
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              that = this;
              param = {
                "fun": "getMsdsDescByKeyword",
                "version": "1",
                "param": {
                  "keyword": that.searchInput,
                  "pageNo": that.page.pageNo,
                  "pageSize": that.page.pageSize
                }
              };
              jsonParam = {
                jsonParamete: JSON.stringify(param)
              };
              _context.next = 10;
              return (0, _api.apiGetMsdsDescByKeyword)(jsonParam);
            case 10:
              _yield$apiGetMsdsDesc = _context.sent;
              data = _yield$apiGetMsdsDesc.data;
              loadInstance.close();
              if (data.proCode == '200') {
                if (data.proData.length > 0 && !isSearch) {
                  that.listData.content = that.listData.content.concat(data.proData);
                  if (isMore) {
                    setTimeout(function () {
                      _this.$refs.content.scrollTop = scrollTop;
                    }, 100);
                  }
                  that.isNodata = false;
                } else if (data.proData.length > 0 && isSearch) {
                  that.listData.content = data.proData;
                  that.isNodata = false;
                } else {
                  that.listData.content = [];
                  that.isNodata = true;
                }
                if (data.proData.length == 10) {
                  that.isNoMoredata = false;
                } else {
                  that.isNoMoredata = true;
                }
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getMsdsList() {
        return _getMsdsList.apply(this, arguments);
      }
      return getMsdsList;
    }(),
    // 获取右侧广告
    getAdvertData: function () {
      var _getAdvertData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(showType, userId) {
        var that, _yield$apiGetAdvertis, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return (0, _api.apiGetAdvertiseData)({
                showType: showType,
                userId: userId
              });
            case 3:
              _yield$apiGetAdvertis = _context2.sent;
              data = _yield$apiGetAdvertis.data;
              if (data.proCode == '200') {
                that.advertData = data.proData;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getAdvertData(_x, _x2) {
        return _getAdvertData.apply(this, arguments);
      }
      return getAdvertData;
    }(),
    // 获取右侧最新资讯的请求
    gethotspotData: function () {
      var _gethotspotData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, param, _yield$apiGetpcamm, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              param = {
                "keyword": that.searchInput,
                "pageNo": 1,
                "pageSize": 4
              };
              _context3.next = 4;
              return (0, _api.apiGetpcamm)(param);
            case 4:
              _yield$apiGetpcamm = _context3.sent;
              data = _yield$apiGetpcamm.data;
              if (data.proCode == '200') {
                that.hotspotData = data.proData;
                // 循环处理发布时间
                that.hotspotData = that.hotspotData.content.filter(function (item) {
                  var date;
                  if (typeof item.articleReleaseTime === 'string') {
                    date = new Date(item.articleReleaseTime.replace(/-/g, '/').replace(/T|Z/g, ' ').trim());
                  } else if ((0, _typeof2.default)(item.articleReleaseTime) === 'object') {
                    date = new Date(item.articleReleaseTime);
                  }
                  item.articleReleaseTime = parseInt(date.getMonth()) + 1 + '-' + date.getDate();
                  return item;
                });
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function gethotspotData() {
        return _gethotspotData.apply(this, arguments);
      }
      return gethotspotData;
    }(),
    // 处理一类二类的展示logo以及文本
    getHazardCategory: function getHazardCategory(hazardCategory) {
      var txt = '';
      var src = null;
      var hcArr = [];
      if (hazardCategory) {
        hcArr = hazardCategory.split('.');
        if (hcArr[0] == 1) {
          txt = '一类';
          src = require("../../../assets/static/img/msds/hazardCategory1.png");
        } else if (hcArr[0] == 2) {
          txt = '二类';
          src = require("../../../assets/static/img/msds/hazardCategory2.png");
        } else if (hcArr[0] == 3) {
          txt = '三类';
          src = require("../../../assets/static/img/msds/hazardCategory3.png");
        } else if (hcArr[0] == 4) {
          txt = '四类';
          src = require("../../../assets/static/img/msds/hazardCategory4.png");
        } else if (hcArr[0] == 5) {
          txt = '五类';
          src = require("../../../assets/static/img/msds/hazardCategory5.png");
        } else if (hcArr[0] == 6) {
          txt = '六类';
          src = require("../../../assets/static/img/msds/hazardCategory6.png");
        } else if (hcArr[0] == 7) {
          txt = '七类';
          src = require("../../../assets/static/img/msds/hazardCategory7.png");
        } else if (hcArr[0] == 8) {
          txt = '八类';
          src = require("../../../assets/static/img/msds/hazardCategory8.png");
        } else if (hcArr[0] == 9) {
          txt = '九类';
          src = require("../../../assets/static/img/msds/hazardCategory9.png");
        }
      }
      return {
        txt: txt,
        src: src
      };
    },
    throttle: function throttle(fn) {
      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var that = this;
      var canRun = true;
      return function () {
        var _arguments = arguments;
        if (!canRun) return;
        canRun = false;
        setTimeout(function () {
          fn.apply(that, _arguments);
          canRun = true;
        }, interval);
      };
    },
    //监听滑动调用的函数
    handleScroll: function handleScroll() {
      var that = this;
      var scrollTop = that.$refs.content.scrollTop;
      if (scrollTop > 0) {
        that.hasHeaderShadow = true;
      } else {
        that.hasHeaderShadow = false;
      }
    }
  }
};